import React, { RefObject } from 'react';

import { Currency, Input, Wrapper } from './styles';

export interface Props {
  name: string;
  value?: string;
  type?: 'text' | 'number' | 'tel';
  placeHolder?: string;
  maxLength?: number;
  handleChange?: (val: any) => void;
  onBlur?: () => void;
  onEnterClick?: () => void;
  forwardRef?: RefObject<HTMLInputElement>;
  style?: React.CSSProperties;
  currency?: string;
  tabIndex?: number;
  disabled?: boolean;
  error?: string;
}

const TextInput: React.FC<Props> = ({
  name,
  type = 'text',
  placeHolder = '',
  maxLength,
  value,
  handleChange,
  children,
  onBlur,
  onEnterClick,
  forwardRef,
  style,
  currency,
  tabIndex = 0,
  disabled,
  error,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnterClick) {
      onEnterClick();
    }
  };

  return (
    <Wrapper>
      <Input
        style={style}
        name={name}
        type={type}
        value={value ?? ''}
        maxLength={maxLength}
        placeholder={placeHolder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={onBlur}
        ref={forwardRef}
        tabIndex={tabIndex}
        disabled={disabled}
        error={error}
      />
      {children}
      {currency && <Currency>{currency}</Currency>}
    </Wrapper>
  );
};

export default TextInput;
